
import { getActions } from '../sagas';

/**
 * Command `map.zoomOut`
 *
 * @typedef {Object} MultSceneForApp~Map~Commands~ZoomOut
 * @property {string} command - name of command, has value `map.zoomOut`
 */
function zoomOut(params, dispatch) {
    const addCommand = getActions(dispatch).addCommand;
    addCommand('ZOOM_OUT');
}

export default {
    name: 'map.zoomOut',
    execute: zoomOut
}
